import { render, staticRenderFns } from "./tcontractconfig-add-or-update.vue?vue&type=template&id=55926275&"
import script from "./tcontractconfig-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tcontractconfig-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports